import script from "./BlogTabPosts.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogTabPosts.vue?vue&type=script&setup=true&lang=ts"

import "./BlogTabPosts.vue?vue&type=style&index=0&id=15c949c7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c949c7"]])

export default __exports__